import React, { SVGProps, useId } from "react";
export const ManIcon = (props: SVGProps<SVGSVGElement>) => {
  const a = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      viewBox="0 0 128 128"
      {...props}
    >
      <path
        fill="#e59600"
        d="M99.09 58.61H28.9c-8 0-14.55 6.97-14.55 15.5s6.54 15.5 14.55 15.5h70.2c8 0 14.55-6.97 14.55-15.5s-6.55-15.5-14.56-15.5z"
      />
      <path
        fill="#543930"
        d="M64.11 3.79h-.04C9.78 4.1 19.19 71.7 19.19 71.7s3.28 50.38 42.87 52.04c.14.01.29.01.42.02.52.02 1.06.03 1.6.03h.02c.55 0 1.09-.01 1.63-.03.13 0 .27-.01.4-.02 39.56-1.64 42.23-51.2 42.23-51.2S120.37 4.11 64.11 3.79z"
      />
      <radialGradient
        id={a}
        cx={66.431}
        cy={66.377}
        r={62.322}
        gradientTransform="matrix(0 -.9583 -.7417 0 113.585 127.299)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.794} stopColor="#6d4c41" stopOpacity={0} />
        <stop offset={1} stopColor="#6d4c41" />
      </radialGradient>
      <path
        fill={`url(#${a})`}
        d="M64.11 3.79h-.04C9.78 4.1 19.19 71.7 19.19 71.7s3.4 52.09 44.9 52.09 44.27-51.25 44.27-51.25S120.37 4.11 64.11 3.79z"
      />
      <path
        fill="#ffca28"
        d="M98.67 89.2c-1.67 4.8-4.41 7.27-8.74 8.2-7.08 1.84-9.21-7.77-25.95-7.77s-20.24 9.33-27.23 7.72c-5.52-1.19-7.48-7.13-8.67-11.53-2.89-10.76-.04-36.33.95-38.99a8.163 8.163 0 0 1 9.13-5.21c5.98 1.1 15.51 2.45 26.02 2.45h.23c10.51 0 20.04-1.36 26.02-2.45a8.169 8.169 0 0 1 9.13 5.21c1.08 2.9 4.05 28.13-.89 42.37z"
      />
      <path
        fill="#e59600"
        d="M69.24 85.69c-.15-.06-.29-.09-.44-.11h-9.6c-.15.02-.29.05-.44.11-.87.35-1.35 1.25-.94 2.21.42.96 2.33 3.65 6.18 3.65s5.76-2.69 6.18-3.65c.4-.95-.08-1.85-.94-2.21z"
      />
      <g fill="#6d4c41">
        <path d="M95.56 62.25c.01-.01-3.09-4.92-10.26-4.92s-10.27 4.9-10.27 4.9l.01.01c-.25.35-.41.78-.41 1.25 0 1.19.95 2.15 2.13 2.15.24 0 .84-.18.89-.2 4.3-1.79 7.66-1.79 7.66-1.79s3.34.01 7.63 1.8c.05.03.65.2.89.2 1.18 0 2.13-.96 2.13-2.14 0-.48-.15-.91-.4-1.26zM52.97 62.23c.01-.01-3.09-4.92-10.26-4.92s-10.27 4.9-10.27 4.9l.01.01c-.25.35-.41.78-.41 1.25 0 1.19.95 2.15 2.13 2.15.24 0 .84-.18.89-.2 4.3-1.79 7.66-1.79 7.66-1.79s3.34.01 7.63 1.8c.05.03.65.2.89.2 1.18 0 2.13-.96 2.13-2.14 0-.48-.15-.91-.4-1.26z" />
      </g>
      <g fill="#404040">
        <ellipse cx={42.96} cy={73.33} rx={6.67} ry={6.91} />
        <ellipse cx={85.43} cy={73.33} rx={6.67} ry={6.91} />
      </g>
      <path
        fill="#ffca28"
        d="M64.24 107.43c5.14 0 10.84-3.12 13.63-5.51.74-.62.29-1.83-.68-1.83h-26c-.97 0-1.41 1.21-.68 1.83 2.84 2.39 8.6 5.51 13.73 5.51z"
      />
    </svg>
  );
};
